import View from './view.js'

export default function Logic(props) {
  return <View {...props} isFullScreen={!!document.fullscreenElement} /> //eslint-disable-line
}
